const DAILY = 'DAILY';
const GREATER_THAN = 'GREATER_THAN';

export function getRedReportFilterList(allStats) {
    const keyToStatMap = allStats
        ? allStats.reduce((acc, s) => {
              acc.set(s.statKey, s);
              return acc;
          }, new Map())
        : new Map();

    return [
        {
            num: 1,
            filterType: 'Stats average_time_login',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'average_time_login',
                    operator: GREATER_THAN,
                    number: 4,
                    statLabel: keyToStatMap.get('average_time_login')?.label,
                    statPrefix: `${keyToStatMap.get('average_time_login')?.label}>`,
                },
            },
        },
        {
            num: 2,
            filterType: 'Stats unique_login_count',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'unique_login_count',
                    operator: GREATER_THAN,
                    number: 50,
                    statLabel: keyToStatMap.get('unique_login_count')?.label,
                    statPrefix: `${keyToStatMap.get('unique_login_count')?.label}>`,
                },
            },
        },
        {
            num: 3,
            filterType: 'Stats average_time_doc_views',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'average_time_doc_views',
                    operator: GREATER_THAN,
                    number: 2,
                    statLabel: keyToStatMap.get('average_time_doc_views')?.label,
                    statPrefix: `${keyToStatMap.get('average_time_doc_views')?.label}>`,
                },
            },
        },
        {
            num: 4,
            filterType: 'Stats doc_view_count',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'doc_view_count',
                    operator: GREATER_THAN,
                    number: 100,
                    statLabel: keyToStatMap.get('doc_view_count')?.label,
                    statPrefix: `${keyToStatMap.get('doc_view_count')?.label}>`,
                },
            },
        },
        {
            num: 5,
            filterType: 'Stats average_time_vof_detail_views',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'average_time_vof_detail_views',
                    operator: GREATER_THAN,
                    number: 2,
                    statLabel: keyToStatMap.get('average_time_vof_detail_views')?.label,
                    statPrefix: `${keyToStatMap.get('average_time_vof_detail_views')?.label}>`,
                },
            },
        },
        {
            num: 6,
            filterType: 'Stats vof_detail_view_count',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'vof_detail_view_count',
                    operator: GREATER_THAN,
                    number: 100,
                    statLabel: keyToStatMap.get('vof_detail_view_count')?.label,
                    statPrefix: `${keyToStatMap.get('vof_detail_view_count')?.label}>`,
                },
            },
        },
        {
            num: 7,
            filterType: 'Stats average_time_search',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'average_time_search',
                    operator: GREATER_THAN,
                    number: 2.5,
                    statLabel: keyToStatMap.get('average_time_search')?.label,
                    statPrefix: `${keyToStatMap.get('average_time_search')?.label}>`,
                },
            },
        },
        {
            num: 8,
            filterType: 'Stats search_count',
            filter: {
                statFilter: {
                    filterType: DAILY,
                    statKey: 'search_count',
                    operator: GREATER_THAN,
                    number: 100,
                    statLabel: keyToStatMap.get('search_count')?.label,
                    statPrefix: `${keyToStatMap.get('search_count')?.label}>`,
                },
            },
        },
    ];
}

export function getRedReportPendingFilterList(allStats) {
    const keyToStatMap = allStats
        ? allStats.reduce((acc, s) => {
              acc.set(s.statKey, s);
              return acc;
          }, new Map())
        : new Map();

    return [
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'average_time_login',
                operator: GREATER_THAN,
                number: 4,
                statLabel: keyToStatMap.get('average_time_login')?.label,
                statPrefix: `${keyToStatMap.get('average_time_login')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'unique_login_count',
                operator: GREATER_THAN,
                number: 50,
                statLabel: keyToStatMap.get('unique_login_count')?.label,
                statPrefix: `${keyToStatMap.get('unique_login_count')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'average_time_doc_views',
                operator: GREATER_THAN,
                number: 2,
                statLabel: keyToStatMap.get('average_time_doc_views')?.label,
                statPrefix: `${keyToStatMap.get('average_time_doc_views')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'doc_view_count',
                operator: GREATER_THAN,
                number: 100,
                statLabel: keyToStatMap.get('doc_view_count')?.label,
                statPrefix: `${keyToStatMap.get('doc_view_count')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'average_time_vof_detail_views',
                operator: GREATER_THAN,
                number: 2,
                statLabel: keyToStatMap.get('average_time_vof_detail_views')?.label,
                statPrefix: `${keyToStatMap.get('average_time_vof_detail_views')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'vof_detail_view_count',
                operator: GREATER_THAN,
                number: 100,
                statLabel: keyToStatMap.get('vof_detail_view_count')?.label,
                statPrefix: `${keyToStatMap.get('vof_detail_view_count')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'average_time_search',
                operator: GREATER_THAN,
                number: 2.5,
                statLabel: keyToStatMap.get('average_time_search')?.label,
                statPrefix: `${keyToStatMap.get('average_time_search')?.label}>`,
            },
        },
        {
            statFilter: {
                filterType: DAILY,
                statKey: 'search_count',
                operator: GREATER_THAN,
                number: 100,
                statLabel: keyToStatMap.get('search_count')?.label,
                statPrefix: `${keyToStatMap.get('search_count')?.label}>`,
            },
        },
    ];
}
